export default __webpack_public_path__ + "static/media/FAQ.f7947eae.svg";